import { render, staticRenderFns } from "./DepartmentMemberCheckboxList.vue?vue&type=template&id=3f9bbd81&scoped=true&"
import script from "./DepartmentMemberCheckboxList.vue?vue&type=script&lang=js&"
export * from "./DepartmentMemberCheckboxList.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentMemberCheckboxList.vue?vue&type=style&index=0&id=3f9bbd81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9bbd81",
  null
  
)

export default component.exports